import React from "react";
import { Box, Typography } from "@mui/material";
import { C, FONT, eyebrowSx } from "../accountStyles";

/*
 * A row of key figures (e.g. active bids / leading / outbid).
 * Figures are passed in by the page — computed from data it has already loaded.
 */
export default function BidSummary({ items }) {
  return (
    <Box
      component="dl"
      sx={{
        m: 0,
        mb: { xs: 4, md: 5 },
        display: "grid",
        gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`,
        borderTop: `1px solid ${C.line}`,
        borderBottom: `1px solid ${C.line}`,
      }}
    >
      {items.map((item, i) => (
        <Box
          key={item.label}
          sx={{ py: { xs: 2, md: 3 }, px: { xs: 1.5, md: 3 }, borderLeft: i === 0 ? "none" : `1px solid ${C.line}`, minWidth: 0 }}
        >
          <Typography component="dt" sx={{ ...eyebrowSx, fontSize: { xs: "0.6rem", sm: "0.7rem" }, minHeight: { xs: "2.4em", sm: "auto" } }}>
            {item.label}
          </Typography>
          <Typography
            component="dd"
            sx={{ m: 0, mt: 0.75, fontFamily: FONT, fontSize: { xs: "1.6rem", md: "2.25rem" }, lineHeight: 1, color: item.value ? item.color || C.ink : C.ink }}
          >
            {item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
